var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"value":_vm.snackbarVisible,"timeout":_vm.snackbarTimeout,"color":_vm.snackbarColor,"multi-line":true,"elevation":"24"},on:{"update:value":function($event){_vm.snackbarVisible=$event}}},[_vm._v(" "+_vm._s(_vm.snackbarText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }